// ── i18n bootstrap (D-22) ───────────────────────────────────
// react-i18next with browser language detection. Plans 03/04/05 fill the
// reserved namespaces (auth.login, legal, gdpr.consent, gdpr.deletion, common).
// Imported once at the top of frontend/src/main.tsx so `useTranslation()` is
// available everywhere.

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enJson from './en.json';
import deJson from './de.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: enJson },
      de: { translation: deJson },
    },
  });

export default i18next;
